import * as Immutable from 'immutable';
//noinspection JSUnresolvedVariable
import {store} from 'redux-store';

import filter from 'lodash/filter';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isNull from 'lodash/isNull';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';

import * as UserUtils from 'utils/user-utils';

/**
 * Helper function to authorize a list of items
 * Take a list of arrays
 * @deprecated This doesn't do much, and is more confusing and less flexible than explicitly authorizing each item.
 * @param list
 * @param instance
 * @returns {*}
 */
export const authorizeList = (list, instance = null) => {
    if (isEmpty(list)) {
        return [];
    }

    return filter(list, (item) => {
        if (isArray(item)) {
            return authorize(item[1], instance, item[2]);
        }
        return true;
    }).map((i) => {
        if (isArray(i)) {
            return i[0];
        }
        return i;
    });
};

const getScopeInfo = (scope) => {
    if (!isString(scope)) {
        return {
            value: null,
            isNegated: false,
        };
    }

    let isNegated = false;
    let value = scope;
    const prefix = scope[0];

    if (prefix === '!') {
        isNegated = true;
        value = scope.slice(1);
    }

    return {
        value,
        isNegated,
    };
};

const validateScope = (acl, p) => {
    const scope = getScopeInfo(p);

    return acl.includes(scope.value) !== scope.isNegated;
};

const isAuthorized = (acl, permissionsOrFeatures, overrides = Immutable.List()) => {
    let isAuth = false;

    if (isArray(permissionsOrFeatures)) {
        permissionsOrFeatures.forEach((p) => {
            if (validateScope(acl, p)) {
                isAuth = true;
            }
        });

        if (!isAuth && !overrides.isEmpty()) {
            permissionsOrFeatures.forEach((p) => {
                if (validateScope(overrides, p)) {
                    isAuth = true;
                }
            });
        }
    } else {
        isAuth = validateScope(acl.concat(overrides), permissionsOrFeatures);
    }

    return isAuth;
};

/**
 * Return true or false based on permission or feature
 * Relies on SessionStore.acl from ReduxStore
 * @deprecated Use authorization-utils.js instead.
 * @param permission
 * @param instance A single model instance or an Immutable.List of instances
 * @param feature
 * @param injectStore
 * @returns {boolean}
 */
export const authorize = (permission, instance = null, feature = null, injectStore = null) => {
    const _store = isNull(injectStore) ? store : injectStore;

    try {
        const {acl, user: loggedInUser} = _store.getState().session;
        const userIsSysAdmin = UserUtils.isSystemAdmin(loggedInUser);

        if (!isNil(feature)) {
            if (!isAuthorized(acl.get('client'), feature)) {
                return false;
            }
        }

        // short-circuit all granular permissions checks if user is sys admin
        if (userIsSysAdmin) {
            return true;
        }

        if ((isUndefined(acl) || acl.isEmpty()) && !isEmpty(permission)) {
            return false;
        }

        // validating a feature, not a permission, so at this point
        // it's valid, See MET-3258 for suggested improvement
        if (isEmpty(permission) && !isNil(feature)) {
            return true;
        }

        let instancePermissions = Immutable.List();

        if (instance) {
            if (isArray(instance) || Immutable.List.isList(instance)) {
                // @ts-expect-error TS(2339): Property 'reduce' does not exist on type 'unknown'
                instancePermissions = instance.reduce((a, m) => {
                    if (m.has('acl')) {
                        return a.concat(m.get('acl'));
                    }
                    return a;
                }, instancePermissions);
            } else if (instance.has('acl')) {
                instancePermissions = instance.get('acl');
            }
        }
        return isAuthorized(acl.get('user'), permission, instancePermissions);
    } catch (e) {
        //noinspection JSUnresolvedVariable
        if (__UNIT_TEST__) {
            // In unit test if no store is available or permissionSet
            // always show component
            return true;
        } else {
            // eslint-disable-next-line
            console.log(e);
        }
    }
    return false;
};
